import React from 'react';
import ServiceCardV2 from './ServiceCardV2';

const HEADINGS = {
  en: { eyebrow: 'CAPABILITIES', title: 'Six ways illumi.dev works with a business.' },
  es: { eyebrow: 'CAPACIDADES', title: 'Seis maneras en que illumi.dev trabaja con un negocio.' },
};

const pad2 = (n) => String(n).padStart(2, '0');

const ServicesGridSectionV2 = ({ services, lang = 'en' }) => {
  const t = HEADINGS[lang] || HEADINGS.en;
  return (
    <section className="iv2-services-grid-section" data-testid="iv2-services-grid-section">
      <div className="iv2-container">
        <div className="iv2-services-grid-head">
          <p className="iv2-section-eyebrow">{t.eyebrow}</p>
          <h2 className="iv2-services-grid-title">{t.title}</h2>
        </div>
        <div className="iv2-services-grid" data-testid="iv2-services-grid">
          {services.map((svc, idx) => (
            <ServiceCardV2
              key={svc.id}
              service={svc}
              lang={lang}
              ordinal={`/ ${pad2(idx + 1)}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGridSectionV2;
